module.exports = __webpack_public_path__ + "static/media/terminal.c129293c.svg";